import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';

import { TooltipVisibility } from '@olympus/ndt-canvas';
import { CanvasCommunicationService, TcgService } from '@olympus/ngx-shared';

import { WindViewPreference } from '../../app.preference';

@Component({
  selector: 'app-view-menu',
  templateUrl: './view-menu.component.html',
  standalone: false,
})
export class ViewMenuComponent implements OnInit, OnDestroy {
  private readonly _subscription: Subscription = new Subscription();

  public cursorsVisibility = false;
  public tooltipVisibility = false;
  public gatesVisibility = false;
  public tcgVisibility = false;

  constructor(
    private readonly _communicationService: CanvasCommunicationService,
    private readonly _preference: WindViewPreference,
    private readonly _tcgService: TcgService,
  ) { }

  public ngOnInit(): void {
    this._subscription.add(
      this._preference
        .get('NDTCanvasWrapperCursorsVisibility')
        .subscribe((cursorsVisibility: boolean) => {
          this.cursorsVisibility = cursorsVisibility;
        }),
    );

    this._subscription.add(
      this._preference
        .get('NDTCanvasWrapperTooltipVisibility')
        .subscribe((tooltipVisibility: TooltipVisibility) => {
          this.tooltipVisibility = tooltipVisibility === TooltipVisibility.ALWAYS;
        }),
    );

    this._subscription.add(
      this._preference
        .get('NDTCanvasWrapperGatesVisibility')
        .subscribe((gatesVisibility: boolean) => {
          this.gatesVisibility = gatesVisibility;
        }),
    );

    this._subscription.add(
      this._tcgService.isTcgVisible$.subscribe((tcgVisibility: boolean) => {
        this.tcgVisibility = tcgVisibility;
      },
      ));
  }

  public ngOnDestroy(): void {
    this._subscription.unsubscribe();
  }

  public handleToggleCursors(checked: boolean): void {
    this._communicationService.context.toggleCursors();
    this._preference.patch('NDTCanvasWrapperCursorsVisibility', checked);
  }

  public handleToggleTooltip(checked: boolean): void {
    const tooltipVisibility: TooltipVisibility = checked ? TooltipVisibility.ALWAYS : TooltipVisibility.ACTIVE;
    this._communicationService.context.tooltipVisibility(tooltipVisibility);
    this._preference.patch('NDTCanvasWrapperTooltipVisibility', tooltipVisibility);
  }

  public handleToggleGates(checked: boolean): void {
    this._communicationService.context.toggleGates(checked);
    this._preference.patch('NDTCanvasWrapperGatesVisibility', checked);
  }

  public handleToggleTcg(checked: boolean): void {
    this._tcgService.setIsTcgVisible(checked);
  }
}
